const lessThanString = (length: number) => ({ message: `Must be ${length} characters or longer` })
const moreThanString = (length: number) => ({ message: `Must be ${length} characters or less` })

export {
    lessThanString,
    moreThanString,
}